import React from 'react';

const URGENCY_COLOR = { critical: '#ff4444', high: '#ffaa00', medium: '#00d4ff' };
const URGENCY_BG = { critical: 'rgba(255,68,68,0.1)', high: 'rgba(255,170,0,0.1)', medium: 'rgba(0,212,255,0.1)' };

export default function LowStockAlert({ data, compact }) {
  if (!data || !data.length) return (
    <div className="inv-empty inv-empty-good">
      <span>✅</span><h3>Stock Levels Healthy</h3><p>No items below threshold</p>
    </div>
  );

  const display = compact ? data.slice(0, 5) : data;
  const critical = data.filter(d => d.urgency === 'critical').length;
  const high = data.filter(d => d.urgency === 'high').length;

  return (
    <div className="inv-chart-container">
      <h2 className="inv-chart-title">
        <span>🔴</span> Low Stock Alerts
        <span className="inv-badge inv-badge-danger">{data.length} items</span>
      </h2>
      {critical > 0 && <div className="inv-alert-banner inv-alert-critical">🚨 {critical} CRITICAL — Stockout within 3 days!</div>}
      {high > 0 && <div className="inv-alert-banner inv-alert-high">⚠️ {high} HIGH URGENCY — Stockout within 7 days</div>}
      <div className="inv-list">
        {display.map((item, i) => (
          <div key={i} className="inv-low-item" style={{ borderLeft: `3px solid ${URGENCY_COLOR[item.urgency]}`, background: URGENCY_BG[item.urgency] }}>
            <div className="inv-urgency" style={{ color: URGENCY_COLOR[item.urgency] }}>{item.urgency.toUpperCase()}</div>
            <div className="inv-item-info">
              <span className="inv-item-title">{item.title}</span>
              {item.variant_title && item.variant_title !== 'Default Title' && <span className="inv-item-sub">{item.variant_title}</span>}
            </div>
            <div className="inv-stats">
              <div className="inv-stat"><span>Stock</span><span style={{ color: URGENCY_COLOR[item.urgency] }}>{item.current_stock}</span></div>
              <div className="inv-stat"><span>Velocity</span><span>{item.daily_velocity}/day</span></div>
              <div className="inv-stat"><span>Stockout In</span><span style={{ color: URGENCY_COLOR[item.urgency] }}>{item.days_until_stockout < 999 ? `${item.days_until_stockout}d` : '∞'}</span></div>
              <div className="inv-stat"><span>Reorder</span><span>{item.reorder_qty} units</span></div>
            </div>
            <div className="inv-stock-bar-wrap">
              <div className="inv-stock-bar" style={{ width: `${Math.min(100, (item.current_stock / Math.max(item.reorder_qty, 1)) * 100)}%`, background: URGENCY_COLOR[item.urgency] }}></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
